module.exports = __webpack_public_path__ + "static/media/175-rapa-nui.d3332b5a.svg";